import React, { useEffect, useState } from "react";
import { APPLICATION_NAME, removeEmptyObjectKey, SOCKET_CHANNEL, SOCKET_URL } from "src/_config";
import { RodeoTvImageComponent } from "src/components/tv-image/tv-image-page";
import { RodeoNewTvImageComponent } from "src/components/tv-image/tv-image-page-new";
import useSocket from "use-socket.io-client";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useParams } from "react-router";

export default function RodeoTvImageContainer() {
  const eventApi = useEventApi();
  const { gameId } = useParams<any>();

  const [globalTvData, setGlobalTvData] = useState<any>();
  const [socketChannel, setSocketChannel] = useState<any>();
  const [rodeoEventId, setRodeoEventId] = useState<any>();

  const getTvImageDetails = (screen1: string, type: any) => {
    // let reId = localStorage.getItem("rodeoEventId");
    const params = {
      screen1,
      type,
    };
    eventApi.callTvImageDetails(
      removeEmptyObjectKey(params),
      (message: string, resp: any) => {
        console.log({ resp });
        setRodeoEventId(resp?.rodeo_event_dtls?.id);
      },
      (message: string) => {
        console.error(`Error at API Access => ${message}`);
      }
    );
  };

  useEffect(() => {
    getTvImageDetails(gameId, null);
    const prevTitle = document.title;
    document.title = `${APPLICATION_NAME} : TV Leaderboard`;
    return () => {
      document.title = prevTitle;
    };
  }, []);

  //Socket Implementation start here
  const [socket] = useSocket(SOCKET_URL, {
    autoConnect: false,
    transports: ['websocket', 'polling'], // Prefer websocket, fallback to polling
    upgrade: true,
    rememberUpgrade: true,
  });

  useEffect(() => {
    socket.connect();

    Object.values(SOCKET_CHANNEL).map((item: any) =>
      socket.on(item, (data: any) => {
        console.log({ item, data });
        setGlobalTvData(data);
        setSocketChannel(item);
      })
    );

    return () => {
      socket.disconnect();
    };
  }, [socket]);

  return (
    <React.Fragment>
      <RodeoTvImageComponent
        globalTvData={globalTvData}
        socketChannel={socketChannel}
        setGlobalTvData={setGlobalTvData}
        setSocketChannel={setSocketChannel}
        rodeoEventId={rodeoEventId}
      />
    </React.Fragment>
  );
}
